// 🎬 Демо-режим (з 14.10.2026): вигадані дані, щоб показати можливості сайту людині за посиланням /?demo=<токен>.
// Дані живуть ЛИШЕ тут, у коді сайту — у базу нічого не пишеться, видаляти потім нічого не треба.
// Телефони навмисно неіснуючі (+380 00 000 00 xx), назви вигадані, у кожного елемента позначка «ДЕМО».
// Координати — поруч із центром міста регіону (маршрут веде саме туди), назви вулиць типові, НЕ звірені з реальною картою.

const STREETS = ['вул. Промислова', 'вул. Заводська', 'вул. Індустріальна', 'вул. Залізнична', 'вул. Складська', 'вул. Виробнича', 'вул. Механізаторів', 'вул. Транспортна'];
// детермінований «випадок»: при кожному відкритті ті самі дані, нічого не стрибає
const rnd = (seed) => { const x = Math.sin(seed * 9301 + 49297) * 233280; return x - Math.floor(x); };
const phone = (n) => '+380000000' + String(n).padStart(3, '0'); // +380 000 000 xxx — неіснуючі

// regions — масив REGIONS з App.js ({ region, lat, lng }); basePrice(region) — справжня середня ціна регіону з картки (або null)
export const buildDemo = (regions, basePrice) => {
  let ph = 1;
  const points = [];
  regions.forEach((r, ri) => {
    const n = 2 + Math.floor(rnd(ri + 1) * 3); // 2–4 точки на регіон
    const base = basePrice(r.region) || 2500;
    for (let k = 0; k < n; k++) {
      const s = ri * 10 + k + 1;
      const price = Math.max(1000, Math.round((base + (rnd(s) - 0.5) * 500) / 50) * 50);
      points.push({
        id: 'demo-pt-' + s, demo: true, region: r.region, city: r.region,
        name: 'Пункт прийому №' + (10 + s),
        address: STREETS[s % STREETS.length] + ', ' + (2 + Math.floor(rnd(s + 7) * 120)),
        lat: r.lat + (rnd(s + 3) - 0.5) * 0.014, lng: r.lng + (rnd(s + 5) - 0.5) * 0.02, // ≈ до 800 м від центру (щоб не впасти в річку)
        price, phone: phone(ph++), precise: true, confirmedAt: Date.now() - Math.floor(rnd(s + 9) * 4) * 86400000,
      });
    }
  });

  const pick = (i) => regions[(i * 7) % regions.length];
  const near = (r, s) => ({ lat: r.lat + (rnd(s) - 0.5) * 0.012, lng: r.lng + (rnd(s + 1) - 0.5) * 0.018 });
  const ago = (d) => ({ seconds: Math.floor((Date.now() - d * 86400000) / 1000) });
  const sellTexts = ['Чорний брухт 3А, близько 5 т, різаний, самовивіз або доставка', 'Брухт після демонтажу ангару, металоконструкції ~12 т', 'Автомобіль на брухт, без двигуна, ~1 т', 'Труби б/у, 8 т, можна частинами', 'Лом 5А, стружка, 3 т, звертайтесь', 'Арматура і швелер з будмайданчика, ~2 т'];
  const buyTexts = ['Купуємо чорний брухт від 1 т, вивіз власним транспортом, розрахунок на місці', 'Приймаємо брухт 3А, 5А, стружку. Ваги поверені', 'Купую металобрухт великими партіями, демонтаж своїми силами', 'Скуповуємо б/у труби і металоконструкції', 'Прийом брухту кольорових і чорних металів, чесні ваги', 'Купуємо автомобілі на брухт, евакуатор безкоштовно'];
  const trTexts = ['Перевезення брухту ломовозом 20 т по області і Україні', 'Маніпулятор 10 т з грейфером, завантаження брухту', 'Тралова перевезення спецтехніки та перевантажувачів', 'Самоскид 25 т, вивіз брухту з об\'єктів'];
  const nicks = ['Металіст', 'Сергій М.', 'БрухтТранс', 'Олег', 'Приймальня-Схід', 'Андрій П.', 'МетКом', 'Василь'];
  const ad = (type, i, text, price) => {
    const r = pick(i + (type === 'buy' ? 3 : type === 'transport' ? 9 : 0));
    const s = 500 + i + (type === 'buy' ? 50 : type === 'transport' ? 90 : 0);
    return { id: 'demo-ad-' + type + '-' + i, demo: true, type, region: r.region, city: r.region, nick: nicks[(i + s) % nicks.length], text, price,
      phone: phone(ph++), address: STREETS[s % STREETS.length] + ', ' + (5 + i * 7) + ', ' + r.region, ...near(r, s), photos: [], createdAt: ago(i % 5), views: 0 };
  };
  const sell = sellTexts.map((t, i) => ad('sell', i, t, 2000 + i * 150));
  const buy = buyTexts.map((t, i) => ad('buy', i, t, 2200 + i * 120));
  const transport = trTexts.map((t, i) => ad('transport', i, t, 45 + i * 5));

  const jobsList = [
    ['hire', 'Приймальник металобрухту', '28 000 грн', 'Графік 5/2, офіційне працевлаштування, навчання на місці'],
    ['hire', 'Водій кат. С (ломовоз)', '35 000 грн', 'Робота по області, досвід від 1 року'],
    ['hire', 'Фуксист / машиніст перевантажувача', '40 000 грн', 'Перевантажувач Fuchs, змінний графік'],
    ['seek', 'Газорізальник, досвід 6 років', '30 000 грн', 'Розглядаю роботу на приймальні або демонтажі'],
    ['seek', 'Водій кат. С, Е', '', 'Шукаю роботу на ломовозі, можливі відрядження'],
  ];
  const jobs = jobsList.map(([kind, title, salary, text], i) => {
    const r = pick(i + 5);
    return { id: 'demo-job-' + i, demo: true, kind, region: r.region, city: r.region, title, salary, text, phone: phone(ph++), confirmedAt: Date.now() - i * 86400000 };
  });

  return { points, sell, buy, transport, jobs };
};
